import React, { useState } from 'react';
import { Box, Card, Grid, Link, Typography } from '@mui/material';
import GenericLoader from '../../components/Loader/GenericLoader';
import { TimesheetsComponentLoaderAttribute } from '../../constants';
import Tiles from '../../components/Tiles/Tiles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCodeCompare,
  faCircleQuestion,
  faFileLines,
  faBookOpen,
} from '@fortawesome/free-solid-svg-icons';
import { faGitAlt } from '@fortawesome/free-brands-svg-icons';
import FeedbackIcon from '@mui/icons-material/Feedback';

const Dashboard = () => {
  const [showError, setShowError] = useState(false);

  const [loader, setLoader] = React.useState(false);

  return (
    <>
      <div>
        {loader ? (
          <div>
            <GenericLoader
              rectAttributes={TimesheetsComponentLoaderAttribute}
              showError={showError}
              setShowError={setShowError}
            />
          </div>
        ) : (
          <Box className="main-content-overlay">
            <Box className="main-content-div">
              <Card elevation={0}>
                {/* <Grid container columns={{ xs: 12 }} rowSpacing={0}>
                <Grid
                  item
                  sx={{ justifyContent: "space-between" }}
                  container
                  columns={{ xs: 8, md: 9 }}
                  rowSpacing={4}
                > */}
                <Grid
                  item
                  // md={4.2}
                  xs={12}
                  container
                  columns={{ xs: 12, sm: 12, md: 12 }}
                  columnSpacing={0}
                  rowSpacing={0}
                  sx={{ height: 'fit-content' }}
                >
                  <Tiles />
                  {/* </Grid> */}
                  {/* <Grid item md={5.8} xs={8}>
                    <TaskStatics />
                  </Grid> */}
                  {/* </Grid> */}
                  {/* <Grid
                  item
                  md={8}
                  xs={12}
                  container
                  columns={{ xs: 12, md: 6 }}
                  columnSpacing={0}
                  rowSpacing={0}
                >
                  <TimingStatistics />
                </Grid> */}
                </Grid>
              </Card>
            </Box>
          </Box>
        )}
      </div>
      <Box
        // component="footer"
        sx={{
          padding: '0.7em',
          backgroundColor: '#fff',
          borderTop: '1px solid #ddd',
        }}
      >
        <Grid
          spacing={2}
          justifyContent="space-around"
          alignItems="center"
          sx={{
            display: 'flex',
          }}
        >
          <Link
            href="https://git.beehyv.com/"
            underline="hover"
            color="inherit"
            target="_blank"
            sx={{ fontSize: '1.15rem', fontStyle: 'italic' }}
          >
            <FontAwesomeIcon
              icon={faGitAlt}
              style={{ marginRight: '0.2rem' }}
            />
            GitLab
          </Link>
          <br />
          <Link
            href="https://sq.beehyv.com/"
            underline="hover"
            color="inherit"
            target="_blank"
            sx={{ fontSize: '1.15rem', fontStyle: 'italic' }}
          >
            <FontAwesomeIcon
              icon={faCodeCompare}
              style={{ marginRight: '0.2rem' }}
            />
            SonarQube
          </Link>
          <br />

          <Link
            href="https://moodle.beehyv.com/"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            color="inherit"
            sx={{ fontSize: '1.15rem', fontStyle: 'italic' }}
          >
            <FontAwesomeIcon
              icon={faBookOpen}
              style={{ marginRight: '0.3rem' }}
            />
            Moodle Training
          </Link>
          <br />
          <Link
            href="https://wiki.beehyv.com/"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            color="inherit"
            sx={{ fontSize: '1.15rem', fontStyle: 'italic' }}
          >
            <FontAwesomeIcon
              icon={faFileLines}
              style={{ marginRight: '0.3rem' }}
            />
            Beehyv Wiki
          </Link>
          <br />

          <Link
            href="https://teams.microsoft.com/l/channel/19:61aee82bf77042d8ab5f8e2c4f017c13%40thread.tacv2/It-support?groupId=74c82718-0f4f-443b-a5cf-c1eaad61d764&tenantId=6bc0be30-e915-48c7-a295-e414c3045548"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            color="inherit"
            sx={{ fontSize: '1.15rem', fontStyle: 'italic' }}
          >
            <FontAwesomeIcon
              icon={faCircleQuestion}
              style={{ marginRight: '0.2rem' }}
            />
            IT Helpdesk
          </Link>
          <br />
          <Link
            href="https://forms.office.com/r/qS26MSRf7M"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            sx={{ fontSize: '1.15rem', fontStyle: 'italic' }}
            color="inherit"
          >
            <FeedbackIcon
              style={{ fontSize: 22, padding: '1.5px', marginRight: '0.2rem' }}
            />
            Feedback Form
          </Link>
        </Grid>
      </Box>
    </>
  );
};

export default Dashboard;
